import React, { useRef, useState, useEffect } from "react";
import { useLockFn } from "ahooks";
import { Input, Table, Button, Form, Upload, Image, message } from "antd";
import { YhForm } from "@components/YhFormBox";
import { YhBox } from "@src/components/YhBox";
import { globalPrompt } from "@src/components/YhMessage";
import { useNavModel, RouterParamType } from "@src/model/navModel";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@components/YhFormBox/Types";
import { PlusCircleOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { EditableCell, EditableRow } from "@components/YHEditTable/editTable";
import { getBaseImgUploadUrl, getBaseUploadData, getBaseImgLookUrl } from "@src/utils/constants";
import { momentDateFormat } from '@src/utils/utils'
import { userService } from "../../../user/UserService";
import { rosterService } from "../../rosterService";
import { rosterDetailsModels } from "./rosterDetailsModels";
import YhUploadForm from '@src/components/YhUploadForm';
import YhUploadTable from '@src/components/YhUploadTable';
import moment from "moment";

export const EmployeeInfo: React.FC = () => {
  const { getSelectedNavState } = useNavModel();
  const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
  const { id, mode } = detailsInfo;
  const {
    loadDs, getDetail, getFormInfo, onCancel, guid,
    hukouTypeDs, hujiTypeDs, educationalTypeDs, certificateTypeDs,
  } = rosterDetailsModels();

  const [emergency, setEmergency] = useState<any[]>([]);
  const [certificate, setCertificate] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const initEmerency = { id: guid(), emergencyContactName: '', emergencyContactPhone: '', emergencyContactRelationship: '' };
  const initCertificate = { id: guid(), certificateName: "", certificateType: "", positionPoints: "", issueDate: "", imgUrl: "", imgName: "", };

  useEffect(() => {
    loadDs("employeeInfo");
    if (mode === "edit") {
      getDetail(id, mode);
      setEmergency(getFormInfo(mode)?.userEmergencyList ?? [initEmerency]);
      setCertificate(getFormInfo(mode)?.userCertificatesVoList?.map((item: any) => ({
        ...item,
        issueDate: item.issueDate ? moment(item.issueDate, 'YYYY-MM-DD HH:mm:ss') : null,
      })));
    }
  }, [detailsInfo]);

  const formRef = useRef<IYhFormRef>();
  const formConfig: IYhForm = {
    formRef,
    labelCol: { span: 9 },
    disabled: false,
    initialValues: getFormInfo(mode),
    justify: 'start',
    items: [
      // {
      //   type: FormItemTypeEnum.Input,
      //   fieldLabel: "籍贯",
      //   fieldName: "nativePlace",
      //   span: 6,
      // },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "身份证号码",
        fieldName: "idNumber",
        span: 6,
      },
      // {
      //   type: FormItemTypeEnum.Select,
      //   fieldLabel: "户口性质",
      //   fieldName: "residenceType",
      //   span: 6,
      //   ds: hukouTypeDs
      // },
      {
        type: FormItemTypeEnum.Select,
        fieldLabel: "学历",
        fieldName: "education",
        span: 6,
        ds: educationalTypeDs
      },
      {
        type: FormItemTypeEnum.Datepicker,
        format: "YYYY-MM-DD",
        fieldLabel: "身份证有效时间",
        fieldName: "idValidity",
        span: 6,
      },
      {
        type: FormItemTypeEnum.Select,
        fieldLabel: "户籍类型",
        fieldName: "householdType",
        span: 6,
        ds: hujiTypeDs
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "专业",
        fieldName: "major",
        span: 6,
      },
      {
        type: FormItemTypeEnum.Datepicker,
        format: "YYYY-MM-DD",
        fieldLabel: "毕业时间",
        fieldName: "graduationDate",
        span: 6,
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "婚姻状况",
        fieldName: "maritalStatus",
        span: 6,
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "毕业院校",
        fieldName: "graduationSchool",
        span: 6,
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "户口本地址",
        fieldName: "residenceAddress",
        span: 6,
      },
      {
        type: FormItemTypeEnum.Other,
        fieldLabel: "身份证/户口本",
        fieldName: "file",
        span: 6,
        formItem:
          <div className="userFileStyle">
            <YhUploadForm
              name="fileList"
              label="身份证/户口本"
              maxCount={4}
              listType={"picture-card"}
              initialValue={getFormInfo(mode)?.userFileList}
              fileUrl={getBaseImgUploadUrl}
              action={getBaseImgUploadUrl()}
              uploadData={getBaseUploadData()}
            />
          </div>
      },
    ]
  };

  const columns = [
    {
      align: "center",
      title: "证书名称",
      width: 100,
      dataIndex: "certificateName",
      editable: true,
      render: (v: any, r: any, i: any) => <span style={{ lineHeight: '28px' }}>{v}</span>,
    },
    {
      align: "center",
      title: "证书类型",
      width: 100,
      dataIndex: "certificateType",
      editType: 'select',
      editable: true,
      options: certificateTypeDs,
      render: (v: any) => {
        const option = certificateTypeDs?.find(item => item.value === v);
        return option ? option.label : v;
      }
    },
    {
      align: "center",
      title: "对应职位分",
      width: 100,
      dataIndex: "positionPoints",
      editable: true,
      render: (v: any, r: any, i: any) => <span style={{ lineHeight: '28px' }}>{v}</span>,
    },
    {
      align: "center",
      title: "颁发时间",
      width: 100,
      dataIndex: "issueDate",
      editType: 'datepicker',
      editable: true,
      render: (v: any) => momentDateFormat(v),
    },
    {
      align: "center",
      title: "附件",
      width: 50,
      dataIndex: "file",
      render: (value: any, row: any, index: any) => {
        return <div className="certificateFileStyle" style={{ height: 70 }}>
          <YhUploadTable
            action={getBaseImgUploadUrl()}
            uploadData={getBaseUploadData()}
            initialValue={row.userFileList}
            listType="picture-card"
            maxCount={1}
            fileUrl={getBaseImgLookUrl}
            rowId={row.id}
            onUpdateRow={(rowId, file, fileList) => {
              // 更新当前行
              const newData = [...certificate];
              const rowIndex = newData.findIndex(item => item.id === rowId);
              if (rowIndex > -1) {
                newData[rowIndex] = {
                  ...newData[rowIndex],
                  userFileList: fileList
                };
                setCertificate(newData);
              }
            }}
          />
        </div>
      }
    },
    {
      align: "center",
      title: "操作",
      width: 50,
      dataIndex: "file",
      render: (t: any, r: any) =>
      (
        <span style={{ fontSize: '14px', color: '#4165E3', cursor: 'pointer' }}
          onClick={() => { setCertificate(certificate.filter(item => item.id !== r.id)); }}
        >删除</span>
      )
    }
  ];

  const newSelectColumns = columns?.map((col: any, index) => {
    return {
      ...col,
      onCell: (record: any, rowIndex: number) => {
        return {
          colIndex: index,
          rowIndex,
          record,
          rules: col.rules,
          options: col.options,
          editType: col.editType,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: (row: any) => {
            const newData = [...certificate];
            const index = newData.findIndex((item) => row.id === item.id);
            const item = newData[index];
            newData.splice(index, 1, { ...item, ...row });
            setCertificate(newData);
          }
        };
      },
    };
  });

  const handleAddEmergency = () => {
    setEmergency([...emergency, { id: guid(), name: '', phone: '', relation: '' }]);
  };

  const handleRemoveEmergency = (index: number) => {
    const newEmergency = emergency.filter((_, i) => i !== index);
    setEmergency(newEmergency);
  };

  const handleEmergencyChange = (index: number, field: string, value: string) => {
    const newEmergency = [...emergency];
    newEmergency[index] = { ...newEmergency[index], [field]: value };
    setEmergency(newEmergency);
  };

  const onSave = useLockFn(async () => {
    setLoading(true);
    try {
      const formData = await formRef.current?.validateFields();
      if (formData) {
        //紧急联系人
        const emergencyParam = {
          "employeeId": getFormInfo(mode)?.id,
          "userEmergencyList": emergency?.map((item: any) => { return { ...item, id: null } })
        }
        const emergencyRet = await rosterService.emergencyInsert(emergencyParam);

        //职业发展技能证书
        const certificatesParam = {
          "employeeId": getFormInfo(mode)?.id,
          "userCertificatesInsertVoList": certificate?.map(cert => ({
            ...cert,
            issueDate: cert.issueDate ? moment(cert.issueDate).format("YYYY-MM-DD") : null
          }))
        }
        const certificatesRet = await rosterService.certificatesInsert(certificatesParam);

        const params = {
          ...formData,
          idValidity: formData.idValidity ? moment(formData.idValidity).format("YYYY-MM-DD") : null,
          graduationDate: formData.graduationDate ? moment(formData.graduationDate).format("YYYY-MM-DD") : null,
          id: getFormInfo(mode)?.id,
          code: getFormInfo(mode)?.code,
          orgCode: getFormInfo(mode)?.orgCode,
          shops: getFormInfo(mode)?.shops,
          roles: getFormInfo(mode)?.roles,
          userFileList: formData.fileList?.map((item: any) => ({ imgUrl: item.uid, imgName: item.name })),
          fileList: [],
        }

        const updateRet = await userService.updateLocal(params);
        if (emergencyRet.success && certificatesRet.success && updateRet.success) {
          await globalPrompt("message", { type: "success", text: '修改成功!' });
        } else {
          await globalPrompt("message", { type: "error", text: "修改失败!" + updateRet.retMsg });
        }
      }
    } catch (e) {
      console.log("失败!");
    } finally {
      setLoading(false);
    }
  })

  const action = (
    <>
      <Button className="mr-5" type="link" shape="round" onClick={() => { onSave() }} loading={loading}>保存</Button>
      <Button className="mr-5" type="link" shape="round" onClick={() => { onCancel(mode) }}>取消</Button>
    </>
  );

  return (
    <YhBox action={action} style={{ overflowY: 'auto', padding: 9, margin: 10 }}>
      <div style={{ padding: 9, fontSize: 18, fontWeight: "bold" }}>员工信息</div>
      <YhForm  {...formConfig} />

      <div style={{ margin: "0px 50px 0px 0px" }}>
        {emergency?.map((item, index) => (
          <div key={index} style={{ display: 'flex', alignItems: 'center', marginTop: 20 }}>
            <div style={{ width: '27%', marginLeft: 5 }}>
              <label>紧急联系人姓名：</label>
              <Input
                value={item.emergencyContactName}
                onChange={(e) => handleEmergencyChange(index, 'emergencyContactName', e.target.value)}
                style={{ width: '58%', marginLeft: 5 }}
              />
            </div>
            <div style={{ width: '27%', marginLeft: -10 }}>
              <label>紧急联系人电话：</label>
              <Input
                value={item.emergencyContactPhone}
                onChange={(e) => handleEmergencyChange(index, 'emergencyContactPhone', e.target.value)}
                style={{ width: '58%', marginLeft: 5 }}
              />
            </div>
            <div style={{ width: '27%', marginLeft: -10 }}>
              <label>紧急联系人关系：</label>
              <Input
                value={item.emergencyContactRelationship}
                onChange={(e) => handleEmergencyChange(index, 'emergencyContactRelationship', e.target.value)}
                style={{ width: '58%' }}
              />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', marginLeft: 100 }}>
              <PlusCircleOutlined onClick={handleAddEmergency} style={{ marginLeft: 10, color: '#0079FE', cursor: 'pointer', verticalAlign: 'baseline', fontSize: 20 }} />
              {emergency.length > 1 && (
                <DeleteOutlined
                  onClick={() => handleRemoveEmergency(index)}
                  style={{ marginLeft: 10, color: '#9292B0', cursor: 'pointer', verticalAlign: 'baseline', fontSize: 20 }}
                />
              )}
            </div>
          </div>
        ))}
      </div>

      <div style={{ padding: 9, fontSize: 18, fontWeight: "bold" }}>职业发展技能证书</div>
      <div className="certificateTableStyle">
        <Table
          rowClassName="editable-row yh-edit-table-tr"
          rowKey={(record, index) => record.id}
          components={{ body: { row: EditableRow, cell: EditableCell } }}
          columns={newSelectColumns}
          dataSource={certificate}
          scroll={{ x: "max-content" }}
          pagination={false}
          footer={() => (
            <span
              style={{ color: 'black', cursor: 'pointer' }}
              onClick={() => {
                const currentCertificate = Array.isArray(certificate) ? certificate : [];
                setCertificate([...currentCertificate, initCertificate]);
              }}
            >
              <PlusOutlined />新增一行
            </span>
          )}
        />
      </div>


    </YhBox>
  );
}